import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { PieChart, Pie, Cell, ResponsiveContainer, Legend, Tooltip } from "recharts";
import { Contact } from "@/types/contacts";

interface EntityTypeChartProps {
  contacts: Contact[];
}

const COLORS = [
  'hsl(var(--chart-1))',
  'hsl(var(--chart-2))',
  'hsl(var(--chart-3))',
];

const TYPE_LABELS: Record<string, string> = {
  restaurant: 'Restaurantes',
  operator: 'Operadoras',
  consolidator: 'Consolidadoras',
};

export const EntityTypeChart = ({ contacts }: EntityTypeChartProps) => {
  const typeCounts = contacts.reduce((acc, contact) => {
    const type = contact.entityType || 'outros';
    acc[type] = (acc[type] || 0) + 1;
    return acc;
  }, {} as Record<string, number>);

  const data = Object.entries(typeCounts).map(([name, value]) => ({
    name: TYPE_LABELS[name] || name,
    value
  }));

  return (
    <Card className="border-border/50">
      <CardHeader>
        <CardTitle className="text-foreground">Distribuição por Tipo</CardTitle>
      </CardHeader>
      <CardContent>
        <ResponsiveContainer width="100%" height={300}>
          <PieChart>
            <Pie
              data={data}
              cx="50%"
              cy="50%"
              labelLine={false}
              label={({ name, percent }) => `${name}: ${(percent * 100).toFixed(0)}%`}
              outerRadius={100}
              fill="#8884d8"
              dataKey="value"
            >
              {data.map((entry, index) => (
                <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
              ))}
            </Pie>
            <Tooltip 
              contentStyle={{ 
                backgroundColor: 'hsl(var(--card))',
                border: '1px solid hsl(var(--border))',
                borderRadius: '8px'
              }}
            />
            <Legend />
          </PieChart>
        </ResponsiveContainer>
      </CardContent>
    </Card>
  );
};
